import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppData } from '@shared/models/appdata.model';
import { Observable } from 'rxjs';
import { DeliveryOptionDetails } from '../models/delivery-options.model';
import { WarehouseStock } from '../models/warehouse-stock.model';

@Injectable({
  providedIn: 'root',
})
export class LogisticsService {
  private http = inject(HttpClient);
  private appData = inject(AppData);

  private apiUrl = this.appData.apiUrl + '/api/v1';

  constructDeliveryOptionsUrl(apiUrl: string, offeringIds: string[], containsReturnBox: boolean): string {
    let url = `${apiUrl}/logistics/delivery-options`;

    if (offeringIds.length > 0) {
      url += `?offeringIds=${offeringIds.filter(Boolean).join('&offeringIds=')}`;
      if (containsReturnBox) {
        url += `&containsReturnBox=${containsReturnBox}`;
      }
    } else {
      if (containsReturnBox) {
        url += `?containsReturnBox=${containsReturnBox}`;
      }
    }

    return url;
  }

  getDeliveryOptionsByOfferingIds(
    offeringIds: string[],
    containsReturnBox: boolean = false
  ): Observable<DeliveryOptionDetails[]> {
    const url = this.constructDeliveryOptionsUrl(this.apiUrl, offeringIds, containsReturnBox);
    return this.http.get<DeliveryOptionDetails[]>(url);
  }

  getSimCardOnlyOption(): Observable<DeliveryOptionDetails> {
    return this.http.get<DeliveryOptionDetails>(`${this.apiUrl}/logistics/delivery-options/simonly`);
  }

  getStockInfoMultipleOfferings(offeringIds: string[]): Observable<WarehouseStock> {
    if (!offeringIds || offeringIds.length === 0) {
      return;
    }

    const BrightstarAndOne2Cel = '1';

    const url = `${this.apiUrl}/logistics/warehouses/${BrightstarAndOne2Cel}/stock?offeringIds`;
    return this.http.post<WarehouseStock>(url, offeringIds);
  }
}
